<template>
  <div class="map-legends-tab py-2">
    <div v-for="group in legendGroups" :key="group.category" class="mb-2">
      <p class="legend-category-heading px-3 pt-2 pb-1 mb-0">
        <small><strong>{{ group.category }}</strong></small>
      </p>
      <div
        v-for="item in group.items"
        :key="group.category + item.name"
        class="legend-item d-flex align-items-center px-3 py-2"
        :class="{ 'legend-item--disabled': !item.pdfUrl }"
        role="button"
        @click="openLegend(item)"
      >
        <img :src="item.image" :alt="item.name" class="legend-thumbnail rounded me-3 flex-shrink-0" />
        <span class="legend-name flex-grow-1">{{ item.name }}</span>
        <span class="material-icons legend-chevron">chevron_right</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import mapStyleInfo from '../../../../../map_style_info.json';

interface LegendItem {
  name: string;
  image: string;
  pdfUrl: string;
}

interface LegendGroup {
  category: string;
  items: LegendItem[];
}

const providers = mapStyleInfo.mapProviders as Record<string, { staticMap: string }>;

function buildItems(legends: { providerId: number; providerName: string; name: string; url: string }[]): LegendItem[] {
  return legends.map(l => ({
    name: l.name,
    image: providers[String(l.providerId)]?.staticMap ?? '',
    pdfUrl: l.url,
  }));
}

export default defineComponent({
  name: 'MapLegendsTab',

  data() {
    return {
      legendGroups: [
        { category: 'Hiking Maps',    items: buildItems(mapStyleInfo.mapStyles.hikingMap.legends)    },
        { category: 'National Maps',  items: buildItems(mapStyleInfo.mapStyles.nationalMap.legends)  },
        { category: 'Historical Maps', items: buildItems(mapStyleInfo.mapStyles.historicalMap.legends) },
      ] as LegendGroup[],
    };
  },

  methods: {
    openLegend(item: LegendItem) {
      if (item.pdfUrl) {
        window.open(item.pdfUrl, '_blank', 'noopener');
      }
    },
  },
});
</script>

<style scoped>
.legend-category-heading {
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.legend-item {
  cursor: pointer;
  border-bottom: 1px solid #2e2e2e;
  transition: background-color 0.15s;
}

.legend-item:last-child {
  border-bottom: none;
}

.legend-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.legend-item--disabled {
  cursor: default;
  opacity: 0.5;
}

.legend-thumbnail {
  width: 52px;
  height: 52px;
  object-fit: cover;
}

.legend-name {
  font-size: 0.9rem;
  line-height: 1.3;
}

.legend-chevron {
  color: #666;
  font-size: 20px;
  flex-shrink: 0;
}
</style>
